import { PulseBaseProvider } from '../../base-classes';


const _nowConditionsApi = '/api/obs/nowconditions/v2';
const _nowConditionsCacheKey = 'nowConditions';

export class NowConditionsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_nowConditionsCacheKey] = this.nowConditionsSyncer.bind(this);
    }

    async nowConditionsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const { latitude, longitude, fml, stationId, providerId, temperatureUnit, stdParameters, roundingProfile, verbose  } = syncParams;
        const queryParams = {
            temperatureUnit,
            ...stdParameters,
            roundingProfile,
            fml,
            verbose
        };
        let apiPath = _nowConditionsApi;
        if (fml) {
            apiPath = `${_nowConditionsApi}/locationType=latitudelongitude/location=${latitude},${longitude}`;
        } else {
            if (stationId && providerId) {
                apiPath = `${_nowConditionsApi}/providerId=${providerId}/stationId=${stationId}`;
            }else{
                apiPath = `${_nowConditionsApi}/locationType=latitudelongitude/location=${latitude},${longitude}`;
            }
            queryParams.locationType = 'latitudelongitude';
            queryParams.location = `${latitude},${longitude}`;
        }
        
        return await super.syncData(syncParams.key, id, queryParams, apiPath, resolve, reject, null, syncParams.pulseApi);
    }

    async getNowConditions(latitude, longitude, fml, stationId, providerId, temperatureUnit, stdParameters, roundingProfile, verbose, refresh = false) {
        const syncParams = {
            latitude,
            longitude,
            fml,
            stationId, 
            providerId, 
            temperatureUnit, 
            stdParameters,
            roundingProfile: roundingProfile ?? 'displayV1',
            verbose: !!verbose,
            refresh
        };
        const id = JSON.stringify(syncParams);
        if (refresh) {
            const key = _nowConditionsCacheKey;
            this.storage.remove({
                key,
                id
            });
        }
        return await super.loadFromStorage(_nowConditionsCacheKey, id, syncParams);
    }
}
